import React from 'react';
import StraightenIcon from '@mui/icons-material/Straighten';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Litres/ha"' },
  { key: 'aliasName', label: 'Alias', helperText: 'e.g. "L/ha"' },
  {
    key: 'baseMultiplier',
    label: 'Base Multiplier',
    required: true,
    type: 'number',
    helperText: 'How many of this unit equal one base unit (e.g. mL/ha = 1000, L/ha = 1)',
  },
];

const UnitManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Unit Management"
    icon={<StraightenIcon />}
    apiPath="/api/units"
    fields={fields}
    entityLabel="Unit"
  />
);

export default UnitManagement;
